/* eslint-disable */

import request from '@/utils/request'
import qs from 'qs'
export function getListRevenueBookingDaily(query) {
  return request({
    url: '/report-service/v1/revenue-report',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getListRevenueBookingDailyExcel(query) {
  return request({
    url: '/report-service/v1/revenue-report/excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
